import React, { useState } from 'react'
import { SetState } from '../../../types/AddressesGroup'
import svgEntreprise from '../../../../assets/images/svg/enterprises/entreprise.svg'
import svgAutoEntreprise from '../../../../assets/images/svg/enterprises/auto-entreprise.svg'

interface SwitchProps {
  setIsCorporation: SetState<boolean>
  currentCountry: string
}

const Switch: React.FC<SwitchProps> = ({
  setIsCorporation,
  currentCountry,
}: SwitchProps) => {
  const values: { [key: string]: boolean } = {
    'auto-entreprise': false,
    entreprise: true,
    sci: false,
  }
  const [value, setValue] = useState<string>(
    currentCountry == 'FR' ? 'auto-entreprise' : 'entreprise'
  )
  const valueChanged = (v: string): void => {
    setValue(v)
    setIsCorporation(values[v])
  }

  return (
    <div className="pr-2 types-subcontainer">
      {currentCountry == 'FR' && (
        <label
          className={
            'enterprise-type p-2 ' +
            (value == 'auto-entreprise' ? 'selected' : '')
          }
        >
          <img
            src={svgAutoEntreprise}
            alt="auto-entreprise"
            loading="lazy"
            width="20px"
            height="19px"
          />
          &#8239; Micro-entreprise
          <input
            type="radio"
            name="type"
            className="is-hidden"
            value="auto-entreprise"
            onChange={ev => valueChanged(ev.currentTarget.value)}
          />
        </label>
      )}

      <label
        className={
          'enterprise-type p-2 ' + (value == 'entreprise' ? 'selected' : '')
        }
      >
        <img
          src={svgEntreprise}
          alt="etoile bleue"
          loading="lazy"
          width="20px"
          height="19px"
        />
        &#8239; Entreprise
        <input
          type="radio"
          name="type"
          className="is-hidden"
          value="entreprise"
          onChange={ev => valueChanged(ev.currentTarget.value)}
        />
      </label>
    </div>
  )
}

export default Switch
